import type { AxiosInstance } from "axios";
import type { EventIdPublic } from "@shared/schemas/branded-id.schemas";
import { dashboardUrl } from "../dashboard/dashboard.api";

export function createDashboardAdminApi(apiClient: AxiosInstance) {
  // Returns unknown: the response is validated by the repo hook's schema parse,
  // not here. An axios response generic would be an unchecked cast, not validation.
  async function getEventDashboard(
    eventIdPublic: EventIdPublic,
  ): Promise<unknown> {
    const response = await apiClient.get(dashboardUrl(eventIdPublic));
    return response.data;
  }

  return { getEventDashboard };
}
